import { faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Form, Formik } from "formik";
import React from "react";
import { Modal } from "react-bootstrap";
import { useDispatch } from "react-redux";
import * as Yup from "yup";
import {
  getPersonalInformation,
  profilePostAction,
} from "../../actions/profileAction";
import FormikControl from "../../components/WraapperComponent/FormikControl";
import { states } from "../../constants/states";
import {
  getUserDetail,
  setUserName,
  setUsetDetailToLocalStorage,
} from "../../utils/helper";
const PersonalInformationPopup = ({ userInfo, closePopup }) => {
  const dispatch = useDispatch();
  const initialValues = {
    firstname: getUserDetail()?.firstName,
    lastname: getUserDetail()?.lastName,
    address_1: userInfo.address_1,
    address_2: userInfo.address_2,
    city: userInfo.city,
    state: userInfo.state,
    phone: userInfo.phone,
    zip: userInfo.zip,
  };

  const validationSchema = Yup.object({
    firstname: Yup.string().nullable().required("This field is required"),
    lastname: Yup.string().nullable().required("This field is required"),
    phone: Yup.string().nullable().required("This field is required"),
    address_1: Yup.string().nullable().required("This field is required"),
    city: Yup.string().nullable().required("This field is required"),
    state: Yup.string().nullable().required("This field is required"),
    zip: Yup.string().nullable().max(5).required("This field is required"),
  });

  const onSubmit = (values) => {
    const data = {
      address_1: values.address_1,
      address_2: values.address_2,
      city: values.city,
      state: values.state,
      zip: values.zip,
      address_id: userInfo.addressId,
      address_nickname: "Contact Address",
    };
    var nameParams = {
      params: {
        action: "userEditPersonalInfo",
        data: { First_Name: values.firstname, Last_Name: values.lastname },
        token: getUserDetail()?.token,
      },
    };
    dispatch(
      profilePostAction(nameParams, () => {
        var user = getUserDetail();
        user.user = {
          first_name: values.firstname,
          last_name: values.lastname,
        };
        setUsetDetailToLocalStorage(user);
        window.dispatchEvent(new Event("storage"));
      })
    );
    var phoneParams = {
      params: {
        action: "userEditPhone",
        data: { phone_number: values.phone },
        token: getUserDetail()?.token,
      },
    };
    dispatch(profilePostAction(phoneParams));
    let actionName = userInfo.addressId ? "userEditAddress" : "userAddAddress";
    var addressParams = {
      params: {
        action: actionName,
        data: data,
        token: getUserDetail()?.token,
      },
    };
    dispatch(
      profilePostAction(addressParams, () => {
        dispatch(getPersonalInformation());
      })
    );
    setUserName(values.firstname, values.lastname);
    closePopup();
  };
  return (
    <Modal size="lg" show={true} backdrop="static">
      <Modal.Header>
        <div className="modal-title">
          <h5 className="profile-title">personal information</h5>
          <div className="close-btn">
            <FontAwesomeIcon icon={faTimesCircle} onClick={closePopup} />
          </div>
        </div>
      </Modal.Header>
      <Modal.Body>
        <div>
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
          >
            {({ errors, touched, setFieldValue, handleBlur }) => {
              return (
                <Form>
                  <div className="row">
                    <div className="col-sm-6">
                      <FormikControl
                        control="forminput"
                        type="text"
                        label="* First Name"
                        name="firstname"
                        handleBlur={handleBlur}
                        hasError={errors.firstname && touched.firstname}
                      />
                    </div>
                    <div className="col-sm-6">
                      <FormikControl
                        control="forminput"
                        type="text"
                        label="* Last Name"
                        name="lastname"
                        handleBlur={handleBlur}
                        hasError={errors.lastname && touched.lastname}
                      />
                    </div>
                    <div className="col-sm-8">
                      <FormikControl
                        control="forminput"
                        type="text"
                        label="* Street"
                        name="address_1"
                        handleBlur={handleBlur}
                        hasError={errors.address_1 && touched.address_1}
                      />
                    </div>
                    <div className="col-sm-4">
                      <FormikControl
                        control="forminput"
                        type="text"
                        label="Apt"
                        name="address_2"
                        handleBlur={handleBlur}
                        hasError={errors.address_2 && touched.address_2}
                      />
                    </div>
                    <div className="col-sm-8">
                      <FormikControl
                        control="forminput"
                        type="text"
                        label="* City"
                        name="city"
                        handleBlur={handleBlur}
                        hasError={errors.city && touched.city}
                      />
                    </div>
                    <div className="col-sm-4">
                      <FormikControl
                        control="dropdown"
                        label="State"
                        name="state"
                        handleBlur={handleBlur}
                        hasError={errors.state && touched.state}
                        options={states}
                      />
                    </div>
                    <div className="col-sm-6">
                      <FormikControl
                        control="forminput"
                        type="text"
                        label="* Phone"
                        name="phone"
                        handleBlur={handleBlur}
                        maxLength={10}
                        onPaste={(e) => {
                          const str = e.clipboardData.getData("Text");
                          const newStr = str.replace(/[^0-9]/g, "");
                          if (str !== newStr) {
                            e.preventDefault();
                            setFieldValue("phone", newStr);
                          }
                        }}
                        hasError={errors.phone && touched.phone}
                      />
                    </div>
                    <div className="col-sm-6">
                      <FormikControl
                        control="forminput"
                        type="text"
                        label="* Zip code"
                        name="zip"
                        handleBlur={handleBlur}
                        maxLength={5}
                        hasError={errors.zip && touched.zip}
                      />
                    </div>
                  </div>
                  <div className="submit-section mt-2">
                    <button className="btn-orange" type="submit">
                      Save
                    </button>
                  </div>
                </Form>
              );
            }}
          </Formik>
        </div>
      </Modal.Body>
    </Modal>
  );
};
export default PersonalInformationPopup;
